import {Component} from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";
import {OurClientsComponent} from "../../../app-persona/our-clients/our-clients.component";
import {FooterPersonaComponent} from "../../../app-persona/footer-persona/footer-persona.component";
import {InfoComponent} from "../info/info.component";

@Component({
  selector: 'app-frecuently-questions',
  standalone: true,
  imports: [
    NgOptimizedImage,
    OurClientsComponent,
    FooterPersonaComponent,
    InfoComponent,
    NgForOf
  ],
  templateUrl: './frecuently-questions.component.html',
  styleUrl: './frecuently-questions.component.css'
})
export class FrecuentlyQuestionsComponent {

  questions = [
    {
      "pregunta": "¿Cuáles son las funciones de un médico ocupacional?",
      "respuesta": "Un médico ocupacional se encarga de cuidar la salud de tus colaboradores, prevenir riesgos laborales, diagnosticar enfermedades relacionadas con el trabajo y asesorarte para crear un entorno laboral seguro y productivo.",
      "id": 1
    },
    {
      "pregunta": "¿Cuál es la diferencia entre un médico ocupacional y un médico general?",
      "respuesta": "El médico general trata cualquier condición de salud, sin un enfoque en el ámbito laboral. El médico ocupacional se especializa en salud laboral, previniendo y manejando riesgos en el trabajo.",
      "id": 2

    },
    {
      "pregunta": "¿Por qué es importante tener un médico ocupacional en mi empresa?",
      "respuesta": "Un médico ocupacional protege la salud de tus colaboradores, reduce riesgos laborales y asegura el cumplimiento de normativas legales como el Reglamento de Seguridad y Salud en el Trabajo.",
      "id": 3

    },
    {
      "pregunta": "¿Cuáles son los beneficios de contar con un médico ocupacional?",
      "respuesta": "Mejora la salud y seguridad laboral, reduce riesgos, previene enfermedades ocupacionales, aumenta la productividad y asegura el cumplimiento de normativas legales. En Grupo Medilink, de tu equipo y de tu empresa",
      "id": 4

    },
  ]

}
